import { MESSAGE_TYPES, MESSAGE_STATUS } from './constants.js';

// BonBoZ: mốc đọc của khách trên khung chat.
//
// Chỉ hai trạng thái được vẽ: `delivered` ra dấu tick, `read` ra avatar khách.
// Avatar đeo ở ĐÚNG MỘT tin — tin gửi đi cuối cùng mà khách đã xem — nên mọi tin
// phía trên nó mặc nhiên là đã xem. Khách đọc thêm thì mốc trôi xuống; mình gửi
// tin mới sau đó thì mốc đứng yên ở tin cũ và tin mới mọc dấu tick.
//
// Hai hàm dưới nằm riêng vì đây là phần dễ sai nhất, và MessageList không test
// trực tiếp được.

/** Tin thật sự đi tới khách. Ghi chú nội bộ không tính. */
export const laTinGuiKhach = message =>
  [MESSAGE_TYPES.OUTGOING, MESSAGE_TYPES.TEMPLATE].includes(
    message?.messageType
  ) && !message?.private;

/** Id tin gửi đi cuối cùng, nơi đeo dấu "đã nhận". */
export const tinCuoiGuiDi = (messages = []) =>
  [...messages].reverse().find(laTinGuiKhach)?.id ?? null;

/**
 * Id tin gửi đi cuối cùng khách đã xem, nơi đeo avatar.
 *
 * Duyệt ngược nên trạng thái về lệch thứ tự vẫn ra đúng: chỉ cần có MỘT tin
 * `read` ở dưới là mốc nằm ở đó, không phụ thuộc các tin trên đã kịp đổi chưa.
 */
export const mocDocCuoi = (messages = []) =>
  [...messages]
    .reverse()
    .find(
      message =>
        laTinGuiKhach(message) && message.status === MESSAGE_STATUS.READ
    )?.id ?? null;
